import React, { Component } from 'react';
import { Badge, Label, Button, InputGroup, InputGroupAddon, InputGroupText, Input } from 'reactstrap';

class CreateNewGuild extends Component {
    render() {
        return (
            <div>
              <div className="passphrase-label">
              Name of new guild:
              </div>
              <InputGroup className="guild-name-input-group">
                <Input
                  autoComplete={"off"}
                  onChange={(event) => this.props.onNameChange(event.target.value)}
                    value={this.props.name}
                    placeholder="Type name for guild" id="guild-name-input"/>
                </InputGroup>
              <div className="passphrase-label">
                Encrypted with passphrase:
              </div>
              <InputGroup className="guild-name-input-group">
                <Input
                  autoComplete={"off"}
                  onChange={(event) => this.props.onPassphraseChange(event.target.value)}
                  value={this.props.passphrase}
                  placeholder="Type passphrase for guild" id="passphrase-input"/>
                </InputGroup>
            </div>
        );
    }
}

export default CreateNewGuild;
